module.exports = __webpack_public_path__ + "static/img/gaozhongwuli.21140106.jpg";